import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, Subject, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { LogCategory, LoggerService, LogService, LogType } from '../core/services/logger.service';

@Injectable()
export class FacilitiesEventService {
    private http = inject(HttpClient);
    private logger = inject(LoggerService);

    public eventForm$: Subject<any> = new Subject<any>();

    constructor() {
        this.log('constructor', null, LogCategory.Constructor);
    }

    public settings$(): Observable<any> {
        return this.http.get<any>(environment.apiUrl + '/facilities/settings')
    }

    public submit$ = this.eventForm$.pipe(
        switchMap((form) => {
            if (!form)
                return of(null);

            const url = `${environment.apiUrl}/facilities/events`;
            this.log("postEvent", url, LogCategory.SubscriptionData);

            return this.http.post<any>(url, form).pipe(
                catchError(error => {
                    this.log('submit$', 'facilities event form submit error', LogCategory.SubscriptionData);
                    return of(error);
                }),
            )
        })
    );

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Service, LogService.FacilitiesEvent, category);
    }
}
